import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/team/page.tsx");
